import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/auth";
import { useHomeContext } from "../../context/HomeContext";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Switch from '@mui/material/Switch';
import { Switch } from '@headlessui/react'
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useThemeContext } from "../../context/ThemeContext";
const Properties = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const { currentMode, setCurrentMode } = useThemeContext();
  const [properties, setProperties] = useState([]);
  const [propertyId, setPropertyId] = useState(null);
  const [hidePropertyId, setHidePropertyId] = useState(null)
  const [unHidePropertyId, setUnHidePropertyId] = useState(null)
  console.log({hidePropertyId})
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const propertyData = useQuery(
    ["propertyDataApi", propertyId,hidePropertyId,unHidePropertyId],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}admin/property`, {
        headers,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setProperties(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );


  const handleHideProperty=(id)=>{
    setHidePropertyId(id)
  }

  const handleUnHideProperty=(id)=>{
    setUnHidePropertyId(id)
  }
  // update property to hide
  const hidePropertyData = useQuery(
    ["hiedPropertyDataApi", hidePropertyId],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}property/find/hide/${hidePropertyId}`, {
        headers,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!hidePropertyId,
      onSuccess: (res) => {
        toast.info(
          "property hided successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setHidePropertyId(null)
      },
    }
  );

  //update property to unhide them 
  const unHidePropertyData = useQuery(
    ["unHiedPropertyDataApi", unHidePropertyId],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}property/find/unhide/${unHidePropertyId}`, {
        headers,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!unHidePropertyId,
      onSuccess: (res) => {
        toast.info(
          "property unHided successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setUnHidePropertyId(null)
      },
    }
  );
  const handleDelete = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6]  p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold">
              Are You Sure, You want to delete this Property ?
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  deletePropertyMutationHandler(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const propertyDeleteMutation = useMutation(
    async (id) =>
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}property/find/${id}`,{headers}
      ),
    {
      retry: false,
    }
  );

  const deletePropertyMutationHandler = async (id) => {
    try {
      propertyDeleteMutation.mutate(id, {
        onSuccess: (responseData) => {
          toast.info(
            "property deleted successfully",
            { theme: "colored" },
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setPropertyId(null);
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message,
            { theme: "colored" },
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
        },
      });
    } catch (err) {
      console.log(err);
    }
  };
  const columns = [
    { field: "index", headerName: "ID", width: 50, headerAlign: "left" },
    {
      field: "images",
      headerName: "Image",
      width: 100,
      renderCell: (params) => {
        return (
          <img
            src={params?.row?.images[0]}
            alt=""
            className="h-10 w-full object-cover rounded-md"
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },

    {
      field: "price",
      headerName: "price",
      width: 100,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "type",
      headerName: "type",
      width: 80,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isFeatured",
      headerName: "isFeatured",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isFurnished",
      headerName: "isFurnished",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "action",
      headerName: "action",
      width: 250,
      renderCell: (params) => {
        return (
          <div className="flex items-center space-x-3">
            <button
              onClick={() => {
                handleDelete(params.row._id);
                setPropertyId(params.row._id);
              }}
              className="bg-red-500 rounded-sm 
                    text-center px-3 p-1 font-medium text-sm text-white"
            >
              Delete
            </button>
            <Link to={"/properties/detail/" + params.row._id}>
              <button
                className="bg-blue-bg rounded-sm text-center
                     px-3 p-1 font-medium text-sm text-white capitalize"
              >
                Detail
              </button>
            </Link>
              <div>
                <Switch
        checked={params.row.isHided}
        onChange={()=>params.row.isHided ? handleUnHideProperty(params.row._id) : handleHideProperty(params.row._id) }
        className={`${params.row.isHided ? 'bg-red-600' : 'bg-[#aeaeae]'}
          relative inline-flex h-[28px] w-[63px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span
          aria-hidden="true"
          className={`${params.row.isHided ? 'translate-x-9' : 'translate-x-0'}
            pointer-events-none inline-block h-[24px] w-[24px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
              </div>
          </div>
        );
      },
    },
  ];

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        // color="secondary"
        // variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        // @ts-expect-error
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }
  return (
    <div className="p-3 md:p-5">
      <div className="bg-white dark:bg-secondary-dark-bg p-2 md:p-5 rounded-lg">
        <div className="flex items-center justify-between py-4">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            Properties
          </h1>
        </div>
        {/*  properties*/}
        {propertyData.isFetched ? (
          propertyData?.data?.data?.data?.length > 0 ? (
            properties?.length > 0 ? (
              <div style={{ height: 530 }} className="">
                <DataGrid
                  rows={properties}
                  columns={columns}
                  pageSize={8}
                  rowsPerPageOptions={[5]}
                  disableSelectionOnClick
                  getRowId={(row) => row._id}
                  sx={{
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    "& .super-app-theme--header": {
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      border: "none",
                    },
                    color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                    border: 2,
                    borderColor: currentMode === "Dark" ? "#475569" : "#64748b",
                    [`& .${gridClasses.cell}`]: {
                      borderColor: (theme) =>
                        currentMode === "Dark" ? "#475569" : "#64748b",
                    },
                    [`& .${gridClasses.row}`]: {
                      borderColor: (theme) =>
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      textAlign: "center",
                    },
                    "& .MuiDataGrid-cellCenter": {
                      justifyContent: "center",
                    },
                    "&.MuiDataGrid-root .MuiDataGrid-cell": {
                      outline: "none",
                      textAlign: "left",
                      border: "none",
                    },
                    "& .MuiPaginationItem-root": {
                      color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                      // backgroundColor:'red'
                      border: "none",
                    },
                  }}
                  components={{
                    Pagination: CustomPagination,
                  }}
                />
              </div>
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )
          ) : (
            <div className="flex items-center justify-center w-full text-center">
              <h1 className="capitalize text-dark-gray text-2xl font-bold text-center">
                You have no properties
              </h1>
            </div>
          )
        ) : (
          <div className="flex items-center justify-center">
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#216fed"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        transition={Slide}
      />
    </div>
  );
};

export default Properties;
